import { FMLanguageDialog, LanguageType } from "@fokused-me/web-ui";
import { useCallback } from "react";
import { useSession } from "../state/Session";

export const LanguagePage = () => {
   const { setLanguage } = useSession();

   const handleOnSelected = useCallback((language: LanguageType) => setLanguage(language), [setLanguage]);

   return <FMLanguageDialog onSelected={handleOnSelected} />;
};
